module.exports = __webpack_public_path__ + "static/img/dark.06c96960.svg";